import React from "react";
import { ApplicationPermissionType } from "ui/Scripts/source/models/enums";
import { SectionIcon, SectionType } from "../SectionIcon";

const getSectionType = (sectionType: ApplicationPermissionType) => {
    switch (sectionType) {
    case ApplicationPermissionType.Company:
        return SectionType.Companies;
    case ApplicationPermissionType.CompanyGroup:
        return SectionType.CompanyGroups;
    case ApplicationPermissionType.Document:
        return SectionType.Documents;
    case ApplicationPermissionType.Event:
        return SectionType.Events;
    case ApplicationPermissionType.InstantMessage:
        return SectionType.InstantMessages;
    case ApplicationPermissionType.Log:
        return SectionType.Log;
    case ApplicationPermissionType.Message:
        return SectionType.CurrentTopics;
    case ApplicationPermissionType.Record:
        return SectionType.UserRecords;
    case ApplicationPermissionType.Task:
        return SectionType.Tasks;
    case ApplicationPermissionType.User:
        return SectionType.Users;
    case ApplicationPermissionType.UserGroup:
        return SectionType.UserGroups;
    case ApplicationPermissionType.WhistleBlow:
        return SectionType.WhistleBlow;
    case ApplicationPermissionType.CalendarTask:
        return SectionType.CalendarTasks;
    case ApplicationPermissionType.AppReport:
        return SectionType.Reports;
    case ApplicationPermissionType.Risk:
        return SectionType.Risks;
    }
};

export const PermissionIcon = ({
    type,
    title,
}: {
  type: ApplicationPermissionType;
  title?: string;
}) => <SectionIcon titleAccess={title} type={getSectionType(type)} />;
